import { Alert, Spin } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"

import { trackEvent } from "lib/eventTracker"

import { putPasswordConfirmation } from "../actions/passwordAuth"
import ConfirmationResendForm from "../components/PasswordAuth/ConfirmationResendForm"
import PasswordAuthLayout from "../components/PasswordAuth/PasswordAuthLayout"
import { confirmationErrorKey } from "../helpers/passwordAuth"
import { useOneTimeTokenFromUrl } from "../hooks/useOneTimeTokenFromUrl"
import { t } from "../lib/i18n"
import routes from "../router/routes"

type ConfirmState =
  | { kind: "confirming" }
  | { kind: "done" }
  | { kind: "failed"; errorKey: string }

// メールのリンク（auth-api の Users::DeviseNotification::CONFIRMATION_PATH）は
// `/password/confirmation?confirmation_token=...`。確認してもトークンは
// 発行されないので、成功したらログイン画面へ案内する。
const EmailConfirm = (): JSX.Element => {
  // URL から消す effect は trackEvent より先に宣言する
  const token = useOneTimeTokenFromUrl("confirmation_token")
  const [state, setState] = useState<ConfirmState>(
    token
      ? { kind: "confirming" }
      : { kind: "failed", errorKey: "email_confirmation_link_invalid" },
  )
  // token は 1 回使うと消えるので、二重に PUT しない
  const requested = useRef(false)

  useEffect(() => {
    trackEvent({ eventName: "Visit Email Confirmation Page" })
    if (!token || requested.current) return
    requested.current = true

    putPasswordConfirmation(token).then((result) => {
      if (result.ok) {
        setState({ kind: "done" })
        return
      }
      setState({ kind: "failed", errorKey: confirmationErrorKey(result) })
    })
  }, [])

  return (
    <PasswordAuthLayout title={t("email_confirm_title")}>
      {state.kind === "confirming" && <Spin />}
      {state.kind === "done" && (
        <>
          <Alert type="success" message={t("email_confirm_done")} />
          <Link to={routes.Login.path}>{t("password_login_submit")}</Link>
        </>
      )}
      {state.kind === "failed" && (
        <>
          <Alert type="error" message={t(state.errorKey)} />
          <ConfirmationResendForm />
          <Link to={routes.Login.path}>{t("back_to_login")}</Link>
        </>
      )}
    </PasswordAuthLayout>
  )
}

export default EmailConfirm
